// Correspondence tab of the dock — the current record's interleaved timeline
// (comments + system events) via the shared CommentsPanel, or an empty state
// when the page isn't a record. Mirrors the Agent tab's anatomy exactly:
// [dock-tabs] [agent-head] [agent-scroll] — one hairline, no card-in-a-card.
import { useEffect } from "react";
import { Icon } from "../design/ui";
import { CommentsPanel } from "../pages/mui/CommentsPanel";
import { useCorrespondence } from "../correspondence/CorrespondenceProvider";
import { markDeskSeenApi } from "../lib/brain-api";

export function CorrespondencePanel() {
  const { target } = useCorrespondence();

  // Opening a record's correspondence marks its threads seen (clears Desk unread).
  const source = target?.source;
  const sourceId = target?.sourceId;
  useEffect(() => {
    if (source && sourceId) void markDeskSeenApi(source, sourceId).catch(() => {});
  }, [source, sourceId]);

  return (
    <>
      <header className="agent-head">
        <div className="agent-head-title">
          <span className="agent-avatar"><Icon name="messages" size={15} /></span>
          <span className="agent-context-chip">
            {target ? (target.label ?? target.sourceId) : "Correspondence"}
          </span>
        </div>
      </header>
      <div className="agent-scroll">
        {target ? (
          <CommentsPanel
            key={`${target.source}:${target.sourceId}`}
            source={target.source}
            sourceId={target.sourceId}
            bare
          />
        ) : (
          <div className="agent-empty">
            <div className="agent-empty-lead">
              No correspondence here. Open a record — a project, customer, visit, person, or plan —
              and its thread shows up in this tab.
            </div>
          </div>
        )}
      </div>
    </>
  );
}
